import React from 'react'

const Splash = () => {
  return (
    <div className="bg-[url('./assets/splash-bg.jpeg')] bg-no-repeat bg-cover bg-center grow grid place-items-center h-screen">
        <img src='./assets/appIcon.png' className='w-[50%]' />
    </div>
  )
}

export default Splash